import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { authClient, usesSso } from '../../auth';

/**
 * EAA-1694: the OIDC redirect target (`${origin}/callback`).
 *
 * Exchanges the authorization code, then sends the browser to the deep link the login
 * started from. `handleCallback` is the shared package's single implementation of the PKCE
 * exchange — the editor adds no crypto or state handling of its own.
 */
const CallbackPage: React.FC = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!usesSso) {
            navigate('/', { replace: true });
            return;
        }
        let cancelled = false;
        void (async () => {
            try {
                const user = await authClient.handleCallback();
                if (cancelled) return;
                // `state` carries the pre-login deep link. Only same-origin paths are
                // followed: an absolute URL from the state parameter is an open-redirect,
                // and the state round-trips through the browser.
                const target = typeof user.state === 'string' ? user.state : '/';
                navigate(target.startsWith('/') ? target : '/', { replace: true });
            } catch (e) {
                if (!cancelled) {
                    setError(e instanceof Error ? e.message : 'Đăng nhập không thành công.');
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [navigate]);

    if (error) {
        return (
            <div className="p-8 space-y-3">
                <h1 className="text-lg font-semibold">Đăng nhập không thành công</h1>
                <p className="text-sm text-muted-foreground">{error}</p>
                <button
                    type="button"
                    className="text-sm underline"
                    onClick={() => navigate('/', { replace: true })}
                >
                    Thử lại
                </button>
            </div>
        );
    }

    return <div className="p-8 text-sm text-muted-foreground">Đang hoàn tất đăng nhập…</div>;
};

export default CallbackPage;
